<template>
    <div>

        <div class="py-2 text-sm">{{$t('fields.select_departament_list')}}</div>
        <div v-for="departament in dataRowsDepartaments" :key="departament.id" class="text-sm flex gap-2 items-center p-0.5 ">
            <div v-html="space(departament.nivel)"></div>
            <div v-if="canSelect(departament)" class="flex items-center gap-2 hover:bg-indigo-50 p-1 px-4" @click="clickCheckbox(departament.id)">
                <div class="relative">
                    <div class="absolute top-0 left-0 right-0 bottom-0"></div>
                    <input type="checkbox" :name="departament.id" :value="departament.id" :checked="verifyChecked(departament.id)" />
                </div>
                <div>
                    {{departament.name}}
                </div>
            </div>
            <div v-else class="flex items-center gap-2 bg-gray-100 p-1 px-4">
                <div class="relative">
                    <div class="absolute top-0 left-0 right-0 bottom-0"></div>
                    <input type="checkbox" class="bg-gray-200 border border-gray-300" />
                </div>
                <div class="text-gray-400">
                    {{departament.name}}
                </div>
            </div>            
        </div>
    </div>  
</template>

<script>

export default {
    name: "TreeDepartaments",

    props: {
        workspace_id: String,
        form_id: String,
        checked: Array,
        canSelect: Function,
        control: String,
        type: String,

    },

    data() {
        return {
            value: [],
            urlDefault: "settings/workspaces",
            linkTo: "settings/workspaces",
            dataRowsDepartaments: [],
            urlControl:  "departamentsForm",
        }
    },

    methods: {
      clickCheckbox(value){
        if(this.checked.indexOf(value) == -1){
            this.checked.push(value);
        } else {
            this.checked.splice(this.checked.indexOf(value), 1);
        }
      },

      verifyChecked(id){
        for (let i = 0; i < this.checked.length; i++) {
            if(this.checked[i] == id){
                return true;
            }
        }
        return false
      },

      async getData() {

        await this.$ApiService.get(`${this.urlDefault}/${this.workspace_id}/${this.urlControl}?forms=true&type=${this.type}`).then(
          (response) => {
            if (response.error) {
              this.errors = this.$FormUtils.showErrors(response.error);
              this.$FormUtils.errorMessage(this.errors.message);
              return;
            }

            this.dataRowsDepartaments = this.$DepartamentsFunctions.organizeDeptos(response.data.departaments); 
          }
        );
      },

      space(n) {
        let space = "";
        for (let i = 0; i < n; i++) {
          space += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
        }
        return space;
      },
    },

    created() {

        if(this.control){
            this.urlControl = this.control;
        }

        this.getData();


    },

    watch: {
        workspace_id() {
            this.getData();
        },       
    },

}
</script>

<style>

</style>